import { useMemo } from "react";

import { Badge, BadgeColor, DetailCardSection, Spinner } from "@prequel/shared-components";

import { useImportLogs } from "@/api/queries/logs";
import { useUsers } from "@/api/queries/users";
import { formatRelativeTime } from "@/pages/import/OverviewPage/helpers";

// Matches the overview endpoint's OverviewItemLimit.
const AUDIT_LOG_LIMIT = 5;

const AuditLogs = () => {
  const { data: logs, isLoading, error } = useImportLogs(AUDIT_LOG_LIMIT);
  const { data: users } = useUsers();

  const emailsByUserID = useMemo(() => new Map((users ?? []).map((user) => [user.id, user.email])), [users]);

  if (isLoading) {
    return (
      <DetailCardSection title="Audit logs">
        <div className="flex justify-center py-6">
          <Spinner size="sm" />
        </div>
      </DetailCardSection>
    );
  }

  if (error) {
    return (
      <DetailCardSection title="Audit logs">
        <p className="py-6 text-center text-sm text-stone-500">Failed to load audit logs.</p>
      </DetailCardSection>
    );
  }

  return (
    <DetailCardSection title="Audit logs">
      {!logs || logs.length === 0 ? (
        <p className="py-6 text-center text-sm text-stone-500">No import activity recorded.</p>
      ) : (
        <div className="divide-y divide-stone-100">
          {logs.map((log) => (
            <div key={log.id} className="grid grid-cols-[2fr_2fr_1fr] items-center gap-4 py-3 text-sm">
              <span className="flex min-w-0 items-center gap-2">
                <Badge text={log.actor.type} color={BadgeColor.GRAY} />
                <span className="truncate text-stone-800">
                  {emailsByUserID.get(log.actor.actor_id) ?? log.actor.actor_id}
                </span>
              </span>
              <span className="min-w-0 truncate font-mono text-xs text-stone-600">{log.event_type}</span>
              <span className="truncate text-right text-stone-500">{formatRelativeTime(log.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </DetailCardSection>
  );
};

export default AuditLogs;
